import React from "react";
import { useAppState } from "../../../Redux/ReduxHooks";
import { BookingDataOwnership, BookingStatus } from "../../../Services/BookingEntities";

/**
 * Component that displays the consent to legal documents (Terms & Conditions, Privacy Policy, Collection Statement). The user doesn't need to click on any button to give the consent. The URLs for the legal documents are retrieved from the state.
 */
export const TermsAndConditions: React.FC = () => {

    const isFixedFareSelected = useAppState(state => state.PhoneToCnp.IsFixedFareSelected);
    const isPaymentConfirmed = useAppState(state => state.PhoneToCnp.IsPaymentConfirmed);
    const LegalDocsPack = useAppState(state => state.legalDocuments.LegalDocumentsPack);
    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking)!;

    // Only applicable when payment options are displayed. i.e. Fixed Fare is selected and payment is not confirmed yet.
    if (isPaymentConfirmed) return null;
    if (!isFixedFareSelected) return null;

    // User's with read-only access (shared booking) can't view this section.
    if (bookingDetails.DataOwnership === BookingDataOwnership.ReadOnlyLink) return null;

    // Already picked up. can't convert the booking anymore. Hence, hide this section and the button.
    if (bookingDetails.TrackingInfo.BookingStatusID >= BookingStatus.PickedUp) return null;

    return (
        <div className="terms-and-conditions">By tapping “Confirm Fixed Price and pay”, you agree to the&nbsp;
            <a href={LegalDocsPack.TermsAndConditionsUrl!} target="_blank">Terms & Conditions</a>, <a href={LegalDocsPack.PrivacyPolicyUrl!} target="_blank">Privacy Policy</a>, and <a href={LegalDocsPack.CollectionStatementUrl!} target="_blank">Collection Statement</a>.</div>
    )
}